import { render, staticRenderFns } from "./add_puestos.vue?vue&type=template&id=0d7c7fc6"
import script from "./add_puestos.vue?vue&type=script&lang=js"
export * from "./add_puestos.vue?vue&type=script&lang=js"
import style0 from "./add_puestos.vue?vue&type=style&index=0&id=0d7c7fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports